import CurrentUserMenu from './CurrentUserMenu';

export default CurrentUserMenu;
